<template>
  <div>
    <div class="container">
      <div class="filterBox flex wrap">
        <div class="box flex">
          <div class="label">反馈来源</div>
          <el-select
            v-model="from"
            placeholder="请选择"
            style="width: 160px"
            @change="search"
          >
            <el-option
              v-for="item in fromList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box flex">
          <div class="label">提交日期</div>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="search"
            style="width: 225px"
          />
        </div>
        <div class="box flex">
          <div class="label">用户昵称</div>
          <el-input v-model="nick_name" style="width: 160px" @change="search" />
        </div>
        <div class="box flex">
          <div class="label">用户电话</div>
          <el-input v-model="phone" style="width: 160px" @change="search" />
        </div>
        <el-button type="info" class="search-button" @click="search"
          >查询</el-button
        >
      </div>
      <!-- 表格 -->
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column label="反馈来源" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.from == 1">用户app</div>
              <div v-if="scope.row.from == 2">诊疗小程序</div>
              <div v-if="scope.row.from == 3">商城小程序</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="提交日期" width="160" />
          <el-table-column label="用户信息" width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.nick_name }}</p>
              <div class="align-center">
                <span> {{ scope.row.user_phone }}</span>
                <img
                  v-if="
                    scope.row.user_phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(5, scope.row.user_id)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="200">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.image.length > 0"
                :src="scope.row.image[0]"
                :preview-src-list="scope.row.image"
              />
            </template>
          </el-table-column>
          <el-table-column prop="content" label="意见反馈" />
          <el-table-column prop="phone" label="联系电话" width="200">
            <template slot-scope="scope">
              <div class="align-center">
                <span> {{ scope.row.phone }}</span>
                <img
                  v-if="
                    scope.row.phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(8, scope.row.id)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="Settle(scope.row.id)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1048') : false
                "
                >处理</el-button
              >
              <el-button
                type="text"
                @click="toUserDetail(scope.row.user_id)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('41') : false
                "
                >查看用户信息</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin: 20px 0"
        ></el-pagination>
      </div>
    </div>
    <!-- 用户反馈处理弹窗 -->
    <el-dialog
      title="用户反馈处理"
      :visible.sync="settleDia"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding-top: 20px; text-align: left">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="问题类型" prop="business_type">
            <el-select
              v-model="ruleForm.business_type"
              placeholder="请选择"
              style="width: 260px"
            >
              <el-option
                v-for="item in queList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理结果" prop="is_result">
            <div style="text-align: left">
              <el-radio v-model="ruleForm.is_result" :label="1"
                >已解决</el-radio
              >
              <el-radio v-model="ruleForm.is_result" :label="2"
                >未解决</el-radio
              >
            </div>
          </el-form-item>
          <el-form-item label="处理意见" prop="result_desc">
            <el-input
              type="textarea"
              :rows="6"
              maxlength="500"
              show-word-limit
              v-model="ruleForm.result_desc"
              style="width: 260px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; padding-bottom: 20px; margin-top: 120px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="settleDia = false"
            style="width: 92px"
            size="medium"
            >关闭</el-button
          >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
            >保存</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      nick_name: "",
      phone: "",
      time: [],
      from: 0,
      fromList: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "用户app",
        },
        {
          value: 2,
          label: "诊疗小程序",
        },
        {
          value: 3,
          label: "商城小程序",
        },
      ],
      settleDia: false,
      queList: [
        {
          value: "咨询指导",
          label: "咨询指导",
        },
        {
          value: "处方指导",
          label: "处方指导",
        },
        {
          value: "物流问题",
          label: "物流问题",
        },
        {
          value: "药品答疑",
          label: "药品答疑",
        },
        {
          value: "功能建议",
          label: "功能建议",
        },
        {
          value: "其他问题",
          label: "其他问题",
        },
      ],
      ruleForm: {
        id: "",
        business_type: "",
        is_result: "",
        result_desc: "",
      },
      rules: {
        business_type: [
          {
            required: true,
            message: "选择问题类型",
            trigger: "blur",
          },
        ],
        is_result: [
          { required: true, message: "请确认处理结果", trigger: "blur" },
        ],
        result_desc: [
          { required: true, message: "请输入处理意见", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取认证记录列表
    getList() {
      let data = {
        nick_name: this.nick_name,
        phone: this.phone,
        from: this.from,
        status: 0,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      if (this.time && this.time.length > 0) {
        data.start_time = dayjs(this.time[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.time[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/activity/getUserFeedbackList", data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.create_time = dayjs
              .unix(ele.create_time)
              .format("YYYY-MM-DD HH:mm");
          });
          this.totalNum = res.data.total;
          this.tableData = list;
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    Settle(id) {
      this.ruleForm = {
        id: id,
        business_type: "",
        is_result: 1,
        result_desc: "",
      };
      this.settleDia = true;
    },
    //添加反馈处理
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          this.axios
            .post("platform/Activity/dealUserFeedback", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("保存成功！");
                this.settleDia = false;
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //用户详情
    toUserDetail(user_id) {
      this.$router.push({
        path: "/home/patient/userdetail",
        query: {
          user_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.phone-box {
  width: 18px;
  height: 18px;
  padding: 0 6px;
  cursor: pointer;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 40px;
    height: 40px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>
